import * as React from 'react';
import { styled } from '@mui/material/styles';

const InputWrapper = styled('div')(
  ({ theme }) => `
  border: 1px solid ${theme.palette.mode === 'dark' ? '#434343' : '#d9d9d9'};
  background-color: ${theme.palette.mode === 'dark' ? '#141414' : '#fff'};
  border-radius: 4px;
  padding: 1px;
  display: flex;
  flex-wrap: wrap;

  &:hover {
    border-color: #23AFC4;
  }

  &.focused {
    border-color: ${theme.palette.mode === 'dark' ? '#177ddc' : '#40a9ff'};
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }

  & input {
    background-color: ${theme.palette.mode === 'dark' ? '#141414' : '#fff'};
    color: ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.65)' : 'rgba(0,0,0,.85)'
    };
    height: 30px;
    box-sizing: border-box;
    padding: 4px 6px;
    min-width: 30px;
    flex-grow: 1;
    border: 0;
    margin: 0;
    outline: 0;
  }
`,
);

const Root = styled('div')(
  ({ theme }) => `
  color: ${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.65)' : 'rgba(0,0,0,.85)'
    };
  font-size: 14px,
`,
);

export default function BasicModal(props) {
  const { setSearchValue } = props

  return (
    <Root>
      <InputWrapper sx={{
        width: {
          xs: '300px',
          sm: '220px',
          md: '220px',
          lg: '370px',
          xl: '300px',
        },
      }}>
        <i className="fa fa-search" style={{ margin: '0.5rem 0.2rem 0.5rem 0.5rem', color: '#ADADAD' }}></i>
        <input style={{marginTop:"2px"}} placeholder={'Search by name and seperate by space'} onChange={(e) => setSearchValue(e.target.value)} />
      </InputWrapper>
    </Root>
  );
}